import TextHelper from '@/core/helpers/TextHelper';

export const optionslist = (itemsProcedure: any[]) => {
  if (!itemsProcedure) return [];
  const transformedArray = itemsProcedure.map((item: any) => ({
    value: item.catalog,
    name: TextHelper.capitalize(item.courseName, false, true)
  }));

  return transformedArray;
};

export const TypeEvaluation = (items: any[]) => {
  if (!items) return [];
  const array = items.map((item: any) => ({
    value: item.order,
    name: TextHelper.capitalize(item.evaluationName, false, true)
  }));

  const sortedArray = array.sort((a, b) => a.value - b.value); // Ordenar por "value"

  return sortedArray;
};

export const NoteCourse = (item: any[]) => {
  if (!item) return [];
  const array = item.map((i: any) => ({
    value: i.id,
    name: i.name
  }));

  return array;
};

export const showNotes = (selectEvaluation?: any, evaluations?: any[]) => {
  let text = '';

  if (!selectEvaluation) {
    text = 'Aparecerá cuando selecciones un curso y evaluación.';
  } else if (evaluations?.length === 0) {
    text = 'Aparecerá cuando selecciones un curso y evaluación.';
  } else {
    const note: any = evaluations?.filter(
      (item) => item.order === selectEvaluation
    );
    text = `${note[0]?.grade}`;
  }

  return text;
};
